module.exports = __webpack_public_path__ + "static/media/patrol(30).13812d92.PNG";